<template>
  <div>
    <div :class="{
        'system-row': true,
        [subscription.mode]: true 
    }">PRO</div>
    <div class="system-comment">${{subscription.price}}/m. | {{ $t('subscription.active_until') }} {{ subscription.paid_until | formatDate}}</div>
  </div>
</template>

<script>
export default {
    props: {
        subscription: Object
    },
    
};
</script>

<style scoped>
.system-row {
  height: 3.5555555555555554vh;
  font-size: 1.5vh;
  background: #000000;
  border-radius: 0.3333333333333333vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}
.inside {
  color: #ededed;
}
.preorder {
  color: #ffd2a8;
}
.delivery {
  color: #cbd9e6;
}
.reserve {
  color: #aeccc6;
}
.pro {
  color: #e2223b;
}
.system-comment {
  font-size: 1.3333333333333333vh;
  line-height: 1.5555555555555556vh;
  color: #aeccc6;
  margin-top: 0.6666666666666666vh;
}
</style>